import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { installAnalytics, pageOpened } from '../lib/analytics'

/**
 * Pola rute untuk nama layar analitik — CERMIN dari `<Routes>` di `App.jsx`.
 *
 * `<Routes>` biasa (bukan data router) tidak menyebut pola yang cocok, jadi
 * daftarnya ditulis di sini. Rute baru yang lupa ditambahkan tidak rusak: ia
 * tercatat dengan jalur mentahnya, segmen angka/uuid diganti `:id`.
 */
const PATTERNS = [
  '/courses/:slug',
  '/checkout/:slug',
  '/p/:slug',
  '/instructor/:slug',
  '/live/:id',
  '/qa/:id',
  '/verify/:code',
  '/learn/:lessonId',
  '/admin/courses/:id',
]

/**
 * Parameter yang ikut dikirim apa adanya di `props`. Slug kelas/pakar/provider
 * dan id numerik itu publik. `code` (kode verifikasi sertifikat) TIDAK — siapa
 * pun yang memegangnya bisa membuka sertifikat orang.
 */
const PARAM_KIRIM = ['slug', 'id', 'lessonId']

const POLA_ID = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

export function screenFor(pathname) {
  for (const pattern of PATTERNS) {
    const m = matchPath({ path: pattern, end: true }, pathname)
    if (!m) continue
    const props = {}
    for (const k of PARAM_KIRIM) if (m.params[k]) props[k] = String(m.params[k]).slice(0, 120)
    return { screen: pattern, props }
  }
  const screen = pathname.split('/').map((s) => (POLA_ID.test(s) ? ':id' : s)).join('/') || '/'
  return { screen, props: {} }
}

let refDone = false

/** Host perujuk dari luar situs, sekali per muat dokumen. Tanpa jalur/query. */
function externalReferrer() {
  if (refDone) return undefined
  refDone = true
  try {
    const h = document.referrer ? new URL(document.referrer).hostname : ''
    return h && h !== window.location.hostname ? h : undefined
  } catch { return undefined }
}

/** Mencatat kunjungan tiap rute (lihat `lib/analytics.js`). Tidak menggambar apa pun. */
export function PageTracker() {
  const { pathname } = useLocation()
  useEffect(() => { installAnalytics() }, [])
  useEffect(() => {
    const { screen, props } = screenFor(pathname)
    const ref = externalReferrer()
    pageOpened(pathname, screen, ref ? { ...props, ref } : props)
  }, [pathname])
  return null
}
